export const ar = {
    // Header
    'header.title': '🎭 كشف كين',
    'header.subtitle': 'Tom Kean Jr. (NJ-7) — لا يهتم بالرعاية الصحية الخاصة بك.',

    // Hero Section
    'hero.quote': 'Tom Kean Jr.: "أقول للناخبين أنني مستقل. ثم أصوت مع MAGA."',
    'hero.subtext': '4 جمهوريين تمردوا لإنقاذ دعم ACA. في 17 ديسمبر، 4 مشرعين جمهوريين أظهروا الشجاعة وانضموا إلى الديمقراطيين لفرض تصويت. Tom Kean Jr. (NJ-7)؟ بقي صامتاً. في ديسمبر، أضاف كين اسمه إلى نداء من الحزب الجمهوري مع 17 سيناتورًا جمهوريًا لتمديد إعانات ACA — لكنه ما زال صوّت مع جمهوريي مجلس النواب لعرقلة التمديد. 22 مليون أمريكي يواجهون زيادة 114% في الأقساط بدءاً من 1 يناير.',

    // Breaking News
    'breaking.news': '🚨 عاجل: Bloomberg: الأميركيون قلقون من تكاليف الصحة أكثر من البنزين أو البقالة',

    // Kean Did Not Support Section
    'kean.betrayal.title': 'TOM KEAN JR. رفض الدفاع عنك',
    'kean.betrayal.text': 'في 17 ديسمبر، 4 جمهوريين من مناطق متأرجحة (Brian Fitzpatrick, Rob Bresnahan Jr., Ryan Mackenzie من بنسلفانيا, وMike Lawler من نيويورك) تمردوا على حزبهم وانضموا إلى الديمقراطيين لفرض تصويت على تمديد دعم ACA. Rep. Tom Kean Jr. (NJ-7) لم يكن منهم. اختار الولاء للحزب على رعايتك الصحية.',
    'kean.betrayal.comparison': 'هؤلاء الجمهوريون الأربعة أظهروا الشجاعة. كين أظهر الجبن.',
    'kean.betrayal.cta': 'اسأل كين: لماذا لم تدافع عنا؟',

    // Healthcare Context Section
    'context.title': 'الجمهوريون لا يهتمون برعايتك الصحية: "تسونامي تكاليف الصحة" أصبح واقعاً',
    'context.intro': 'عضو الكونغرس الجمهوري Tom Kean Jr. (NJ-7) لم يفعل شيئاً لدعم رعايتك الصحية. استعد لدفع المزيد مقابل كل شيء: الأقساط، زيارات الطبيب، الوصفات الطبية. كيف ستتحمل هذا؟ في 16 ديسمبر، صوّت الجمهوريون في مجلس النواب ضد جهود الديمقراطيين لتمديد إعانات ACA. الديمقراطيون يقاتلون من أجل رعايتك الصحية — بتمرير ACA، وخفض أسعار الأدوية الرئيسية، والمزيد. لكن Tom Kean Jr. صوّت مع حزبه للسماح بانتهاء هذه الحمايات.',
    'context.truth.title': 'الحقيقة: التأثير الحقيقي على عائلات نيوجيرسي',
    'context.truth.text': 'تينا جامب، من ماهواه، نيوجيرسي، اكتشفت أن قسط ACA الخاص بها سيرتفع من <strong>400 دولار/شهرياً إلى أكثر من 1,100 دولار/شهرياً</strong> — ما يقرب من ثلاثة أضعاف الزيادة. "لا أعرف كيف سأدفع ذلك،" قالت لـ CBS News.',
    'context.impact': '<strong>22 مليون أمريكي</strong> مؤهلين للإعفاءات الضريبية يواجهون الآن قرارات مالية صعبة. تكاليف الأقساط من الجيب سترتفع <strong>بمتوسط 114%</strong>، بزيادة 1,016 دولار في التكاليف السنوية. عائلة من أربعة تكسب 75,000 دولار/سنة قد ترى زيادة إضافية <strong>3,368 دولار</strong> في الأقساط.',
    'context.tsunami': '"سنرى تسونامي تكاليف الصحة في 1 يناير،" قالت ميشيل ستيرنثال من Community Catalyst. وفقاً لمكتب الميزانية في الكونغرس، قد يتخلى <strong>4 ملايين شخص تقريباً</strong> عن التأمين الصحي بسبب ارتفاع الأقساط.',
    'context.exposed.title': 'كشف: من هو الأكثر عرضة؟',
    'context.exposed.text': 'أصحاب الأعمال الصغيرة والعاملون لحسابهم الخاص معرضون بشكل خاص. حوالي نصف البالغين المسجلين في ACA هم أصحاب أعمال صغيرة، أو يعملون في شركات بأقل من 25 موظفاً، أو يعملون لحسابهم الخاص.',
    'context.accountability': 'صوّت Rep. Tom Kean Jr. (NJ-7) مع حزبه للسماح بانتهاء هذه الإعانات. الديمقراطيون في الكونغرس يقدمون عريضة إخراج للتصويت على تمديد الإعفاءات الضريبية لأقساط ACA. الطريق للفوز بمجلس النواب يمر مباشرة عبر نيوجيرسي. حان الوقت لمحاسبتهم.',
    'context.cta': 'اتخذ إجراءً الآن',

    // ACA Section
    'aca.title': 'الجمهوريون يسلبون رعايتك الصحية — انتهت إعانات ACA في 31 ديسمبر',
    'aca.text': 'عرقل الجمهوريون في مجلس النواب تمديد دعم ACA في 16 ديسمبر. بدءاً من 1 يناير، سترتفع الأقساط بمتوسط 114%. بعض العائلات، مثل مقيم في ماهواه يكسب 72,000 دولار/سنة، سترى التكاليف تتضاعف ثلاث مرات تقريباً — من 400 دولار إلى أكثر من 1,100 دولار شهرياً. صوّت Rep. Tom Kean Jr. (NJ-7) مع حزبه لعرقلة شريان الحياة هذا.',
    'aca.chart.title': 'متوسط زيادة الأقساط',
    'aca.chart.2025': '2025',
    'aca.chart.2026': '2026',
    'aca.chart.withSubsidies': 'مع الدعم',
    'aca.chart.increase': '+114% متوسط',

    // No Kean Day Section
    'nokean.title': 'يوم بدون كين!',
    'nokean.date': '7 فبراير',
    'nokean.message': 'أرسل له رسالة!',
    'nokean.standup': 'دافع عن الرعاية الصحية',
    'nokean.handle': '@CongressmanKean',
    'nokean.caption': '"أتجنب اجتماعات المواطنين لأن المرايا تزعجني."',

    // Voting Record Section
    'voting.title': '📜 السجلات واضحة',
    'voting.record.title': 'سجل تصويت توم كين جونيور',
    'voting.bill.name': 'H.R.1 - قانون One Big Beautiful Bill',
    'voting.bill.congress': 'الكونغرس 119 (2025-2026) | القانون العام 119-21',
    'voting.bill.rollcall': 'تصويت نداء الأسماء #145 | 22 مايو 2025',
    'voting.bill.cut1': '• قطع دعم ACA - زيادة 174% في الأقساط',
    'voting.bill.cut2': '• تخفيض تمويل Medicaid مما يؤثر على عائلات نيوجيرسي',
    'voting.breakdown.title': 'تفاصيل التصويت',
    'voting.breakdown.yeas': '✓ موافق: 215 (جميع الجمهوريين)',
    'voting.breakdown.nays': '✗ معارض: 214 (جميع الديمقراطيين)',
    'voting.breakdown.present': 'حاضر: 1',
    'voting.breakdown.notvoting': 'لم يصوت: 2',
    'voting.breakdown.passed': 'تم التمرير',
    'voting.kean.name': 'توم كين جونيور',
    'voting.kean.title': 'ممثل، NJ-7',
    'voting.kean.vote': 'نعم',
    'voting.kean.result': 'صوّت لقطع الرعاية الصحية',
    'voting.source': 'المصدر: مكتب كاتب مجلس النواب الأمريكي | clerk.house.gov/Votes/2025145',
    'voting.cta.vote': 'شاهد تصويت كين',
    'voting.cta.bill': 'اقرأ مشروع القانون (H.R.1)',

    // Medicaid Section
    'medicaid.title': 'Tom Kean Jr.: "أسميها \'المسؤولية المالية\'"',
    'medicaid.text': 'دعم Rep. Tom Kean Jr. (NJ-7) تخفيضات Medicaid التي تعرض كبار السن والأطفال وذوي الإعاقة للخطر. هذه التخفيضات تقلل الوصول إلى الأطباء والمستشفيات والرعاية طويلة الأمد. كل صوت يتكلم — حتى لو لم يتكلم هو.',
    'medicaid.visual': 'Medicaid = شريان الحياة',
    'medicaid.hashtags': '#كشف_كين #تتبع_المال',
    'medicaid.hashtags.text': '#كشف_كين #تتبع_المال #الجمهوريون_لا_يهتمون_بصحتك',

    // Medicare Section
    'medicare.title': 'Tom Kean Jr.: "لم أفقد صوتي. أعطيته لترامب."',
    'medicare.subtext': 'تتضمن المقترحات الجمهورية مئات المليارات من تخفيضات Medicare. Rep. Tom Kean Jr. (NJ-7) انحاز لهذه الجهود، مما يعرض الرعاية الصحية لكبار السن للخطر.',
    'medicare.bullet1': 'مسودات الميزانية الجمهورية تقترح 479 مليار دولار في تخفيضات Medicare (هياكل الدفع، تغييرات الأهلية).',
    'medicare.bullet2': 'قانون "One Big Beautiful Bill" تضمن أحكاماً تقيد الوصول إلى Medicare.',
    'medicare.bullet3': 'كبار السن في NJ-7 يعتمدون على Medicare للزيارات المستشفوية والأدوية والرعاية طويلة الأمد.',
    'medicare.cta': 'احمِ Medicare — اتخذ إجراءً',
    'medicare.visual': 'Medicare = شريان الحياة.\nامسح رمز QR لاتخاذ إجراء.',

    // Accountability Section
    'accountability.title': 'سقط القناع. حاسبوا Tom Kean Jr.',
    'accountability.text': '"أحياناً الصمت ليس ذهباً. إنه جبن متنكر في ثوب الحذر." سجل Rep. Tom Kean Jr. (NJ-7) واضح: تكاليف أعلى، رعاية أقل، صعوبات أكثر. NJ-7 يستحق الأفضل.',
    'accountability.cta': 'انضم إلى #جمعة_البحث_عن_كين',

    // News Sources Section
    'news.title': '📰 المزيد من السجلات',
    'news.updated': 'تم التحديث في 29 يناير 2026',
    'news.cbs': 'CBS News: الملايين يواجهون زيادات في الأقساط',
    'news.wsj': 'WSJ: شركات التأمين ترد على تجميد مدفوعات ميديكير',
    'news.bloomberg': 'Bloomberg: تكاليف الصحة تقلق أكثر من البنزين أو البقالة',
    'news.nytimes': 'NY Times: 4 جمهوريين يتمردون لفرض تصويت',
    'news.nytimes2': 'NY Times: مجلس النواب يعرقل تمديد دعم أوباماكير',
    'news.nytimes3': 'NY Times: الجمهوريون يدفعون مبادرة الديمقراطيين إلى خط النهاية',

    // Footer
    'footer.tagline': 'الحقيقة تؤلم. الأكاذيب تكلف أكثر. الجمهوريون لا يهتمون برعايتك الصحية.',
    'footer.hashtags': '#كشف_كين #لا_ملوك #الجمهوريون_لا_يهتمون_بصحتك',
    'footer.disclaimer': 'الحقيقة تؤلم. الأكاذيب تكلف أكثر. الجمهوريون لا يهتمون برعايتك الصحية. #كشف_كين #لا_ملوك #RepublicansDontCareAboutYourHealthcare',
    'footer.terms': 'شروط الاستخدام',
    'footer.privacy': 'سياسة الخصوصية',
    'footer.contact': 'اتصل بنا',
};

export default ar;
